export const baseRoleOptions = [
  { value: "professional", label: "Professional" },
  { value: "recruiter", label: "Recruiter" },
];

export const filterRoleOptions = [
  { value: "all", label: "All Roles" },
  { value: "admin", label: "Admin" },
  ...baseRoleOptions,
];
export const documentStatusOptions = [
  { key: "pending", label: "Pending" },
  { key: "verified", label: "Verified" },
  { key: "rejected", label: "Rejected" },
  { key: "needs_resubmission", label: "Needs Resubmission" },
];
